module.exports = __webpack_public_path__ + "static/media/picture 3 - bike.b387f4d9.png";